module.exports = __webpack_public_path__ + "static/img/thumb-01.f282283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/thumb/thumb-01.png
// module id = 79Y/
// module chunks = 31